import { render, staticRenderFns } from "./PocSection.vue?vue&type=template&id=72b323f6&scoped=true"
import script from "./PocSection.vue?vue&type=script&lang=js"
export * from "./PocSection.vue?vue&type=script&lang=js"
import style0 from "./PocSection.vue?vue&type=style&index=0&id=72b323f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b323f6",
  null
  
)

export default component.exports